import React from "react";
import { ArrowLeftCircle, ArrowRightCircle } from "react-feather";
import { Row, Button, Col } from "reactstrap";

export const LoadMoreButtons = ({ setUrl, previous, next }) => {
  return (
    <Row>
      <Col md="6" style={{ textAlign: "left" }}>
        <Button outline onClick={() => setUrl(previous)} disabled={!previous}>
          <ArrowLeftCircle size="20" /> Anterior
        </Button>
      </Col>
      <Col md="6" style={{ textAlign: "right" }}>
        <Button outline onClick={() => setUrl(next)} disabled={!next}>
          Siguiente <ArrowRightCircle size="20" />
        </Button>
      </Col>
    </Row>
  );
};
